import React from 'react';
import {
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  Slide,
} from '@mui/material';
import MUIDialog from '@mui/material/Dialog';
import './UpsellingDialog.less';
import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import { LocalizePropType } from 'getaway-data-layer';

const Transition = React.forwardRef(function Transition(props, ref) {
  // @ts-ignore
  return <Slide direction="up" ref={ref} {...props} />;
});

type props = {
  localize: LocalizePropType;
  showUpsellingDialog: boolean;
  handleYesAction: () => void;
  handleNoAction: () => void;
};

const UpsellingDialog = ({
  localize,
  showUpsellingDialog,
  handleYesAction,
  handleNoAction,
}: props) => {
  return (
    <MUIDialog
      open={showUpsellingDialog}
      // @ts-ignore
      TransitionComponent={Transition}
      keepMounted
      aria-describedby="alert-dialog-slide-description"
    >
      <div style={{ maxWidth: 350 }}>
        <img
          src="/images/upsellingDialog.png"
          alt="upsellingDialog"
          className="dialog-image"
        />

        <DialogTitle sx={{ textAlign: 'center', fontSize: '20px !important' }}>
          {localize('upselling.dialog.title')}
        </DialogTitle>

        <DialogContent sx={{ padding: 0 }}>
          <DialogContentText
            data-testid="Dialog-dialogMessage"
            id="alert-dialog-slide-description"
            sx={{
              width: '100%',
              padding: '0 15px !important',
              textAlign: 'center',
              fontSize: '16px !important',
              color: 'black !important',
              whiteSpace: 'normal',
              wordBreak: 'break-word',
            }}
          >
            <Markdown rehypePlugins={[rehypeRaw]}>
              {localize('upselling.dialog.message')}
            </Markdown>
          </DialogContentText>
        </DialogContent>

        <DialogActions
          data-testid="Dialog-dialogAction"
          sx={{ justifyContent: 'center', padding: '0 24px 24px 20px' }}
        >
          <div className="image-dialog-button-wrapper">
            <button
              data-testid="Dialog-topBtn"
              className="image-dialog-yesAction-button"
              onClick={handleYesAction}
            >
              {localize('upselling.dialog.yesAction')}
            </button>

            <button
              data-testid="Dialog-cancelBtn"
              className="image-dialog-noAction-button"
              onClick={handleNoAction}
            >
              {localize('upselling.dialog.noAction')}
            </button>
          </div>
        </DialogActions>
      </div>
    </MUIDialog>
  );
};

export default UpsellingDialog;
